import React, {FunctionComponent} from "react"
import {PersonalBest} from "/src/domain/challenges/ChallengeUserRatingData";
import {Grid} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {sec2hms} from "/src/utils/time-utils";
import {useTranslation} from "react-i18next";
import {theme} from "/src/assets/theme";
import dayjs from "dayjs";

export type PersonalBestViewProps = {
    pb: PersonalBest
}

export const PersonalBestView: FunctionComponent<PersonalBestViewProps> = ({pb}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div className={classes.container}>
            <div className={classes.containerCard}>
                <h5 className={classes.header}>{t('personalBestLabel')}</h5>
                <Grid container className={classes.resultsHeader}>
                    <Grid item xs={6}
                          container
                          alignItems="center"
                          className={classes.resultsHeaderCategory}>{pb.km} {t('km')}</Grid>
                    <Grid item xs={6}
                          container
                          justifyContent="flex-end"
                          alignItems="center"
                          className={classes.resultsHeaderParameter}>{sec2hms(pb.time_sec)}</Grid>
                </Grid>
                <div className={classes.results}>
                    <div>{pb.challenge_name}</div>
                    <div>{dayjs(pb.challenge_run_start).format('DD.MM.YYYY')}</div>
                </div>
            </div>
        </div>
    );
}

const useStyles = makeStyles(muiTheme => ({
    resultsHeader: {
        backgroundColor: muiTheme.palette.secondary.main,
        color: muiTheme.palette.secondary.contrastText,
        fontSize: '0.9rem',
        fontWeight: 600,
    },
    resultsHeaderCategory: {
        padding: '0.5rem 1.5rem'
    },
    resultsHeaderParameter: {
        background: `url(${require('../../assets/icons/challengeProtocolCurrentUserCardRect.svg')})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        padding: '0.5rem 1.5rem',
    },
    results: {
        padding: '1rem 1.5rem',
        fontSize: '0.9rem',
        lineHeight: '1.5rem',
    },
    containerCard: {
        marginBottom: '0.5rem',
        backgroundColor: theme.lightSecondaryColor,
        borderRadius: '10px',
    },
    header: {
        fontSize: '1.25rem',
        textAlign: 'center',
        padding: '1.5rem',
        fontWeight: 500,
    },
    container: {
        color: muiTheme.palette.secondary.main,
        margin: '0 auto 1rem',
        maxWidth: '35rem',
        fontWeight: 500,
    },
}))